import ApiService from '../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            blanks: [],
            activeTab: 'active',
            successGenerate: false,
            lastUrl: null,
        }
    },
    getters: {
        activeTab: (state) => {
            return state.activeTab;
        },
        successGenerate: (state) => {
            return state.successGenerate;
        }
    },
    mutations: {
        setBlanks(state, value) {
            state.blanks = value;
        },
        addBlank(state, value) {
            state.blanks.data.unshift(value);
        },
        removeBlank(state, item) {
            for (let i = 0; i < state.blanks.data.length; i++) {
                if (state.blanks.data[i].id === item.id) {
                    window.Vue.delete(state.blanks.data, i, item);
                }
            }
        },
        updateBlank(state, item) {
            for (let i = 0; i < state.blanks.data.length; i++) {
                if (state.blanks.data[i].id === item.id) {
                    window.Vue.set(state.blanks.data, i, item);
                }
            }
        },
        setActiveTab(state, value) {
            state.activeTab = value;
        },
        setSuccessGenerate(state, value) {
            state.successGenerate = value;
        }
    },
    actions: {
        index({state, commit, getters}, payload = {}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/blank', payload)
                    .then((response) => {
                        commit('setBlanks', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        allBlank({state, commit, getters}){
            return new Promise((resolve, reject) => {
                ApiService.get('/blank/all')
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getBlank({state, commit, getters} ,id){
            return new Promise((resolve, reject) => {
                ApiService.get('/blank/'+ id)
                    .then((response) => {
                        commit('setForm', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        createBlank({state, commit, getters}, pagesToGenerate){
            return new Promise((resolve, reject) => {
                ApiService.post('/blank', pagesToGenerate)
                    .then((response) => {
                        state.lastUrl = response.data.fileUrl;
                        commit('addBlank',response.data);
                        commit('setSuccessGenerate', true);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    })
            });
        },
        editBlank({state, commit, getters}, form){
            return new Promise((resolve, reject) => {
                ApiService.update('/blank/'+ form.id, form)
                    .then((response) => {
                        commit('updateBlank',response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        deleteItem({state, commit, getters}, id){
            return new Promise((resolve, reject) => {
                ApiService.delete('/blank/'+ id)
                    .then((response) => {
                        commit('removeBlank',response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        restoreItem({state, commit, getters}, id){
            return new Promise((resolve, reject) => {
                ApiService.get('/blank/'+ id + '/restore')
                    .then((response) => {
                        commit('removeBlank',response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
    }
};
